<a #topOfPage id="topOfPage"></a>

<div class="page-content" page-content>
  <prism-ui-heading font-size="lg" font-weight="regular" key-id="physician-info-title" is-uppercase="false"
    variant="default">{{pageTitle}}
  </prism-ui-heading>
  <hr class="horizontalLine" />
  <form [formGroup]="physicianInfoForm" (ngSubmit)="onSubmit()">
    <prism-ui-container is-compact="false" key-id="physician-container" has-shadow="false" variant="default"
      has-no-border-radius="false">
      <div class="form-group">
        <div class="row">
          <prism-ui-copy>
            <p [innerHTML]="hasPhysicianElement?.label"></p>
          </prism-ui-copy>
        </div>
        <div class="containerOne">
          <div class="item oneCell bottomPadding">
            <prism-ui-form-field-select
              [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm,'hasPhysician')"
              [formFieldItemsCount]="radioButtonOptions.length" key-id="appType-name" orientation="vertical" hide-legend="true">
              <span slot="error">One of three selections is required.</span>
            </prism-ui-form-field-select>
            @for (appType of radioButtonOptions; track appType; let index =
            $index) {
            <div id="hasPhysician" formControlName="hasPhysician" slot="input-{{ index + 1 }}">
              <prism-ui-radio-button labelText="{{ appType.label }}" key-id="appType-name" ngDefaultControl
                [name]="appType.name" formControlName="{{ index }}" [checked]="
                  physicianInfoForm.get('hasPhysician').value === appType.name
                " [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm,'hasPhysician')"
                (prismUiRadioButtonOnChange)="
                  logPhysicianRadioChangeEvent(appType.name)
                ">
              </prism-ui-radio-button>
            </div>
            }
          </div>
          @if (physicianInfoForm.get('hasPhysician').value === 'physician') {
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianFirstName" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'physicianFirstName'
                  )
                ">
              <span slot="label">{{ physicianFirstNameElement?.label }}</span>
              <span slot="helper-text">{{
                physicianFirstNameElement?.hint
                }}</span>
              @if (physicianInfoForm.get('physicianFirstName').hasError('required') &&
              physicianInfoForm.get('physicianFirstName').touched) {
              <span slot="error">{{ physicianFirstNameElement?.error }}</span>
              }
              @if (physicianInfoForm.get('physicianFirstName').hasError('maxlength') &&
              physicianInfoForm.get('physicianFirstName').touched) {
              <span slot="error">{{ physicianFirstNameElement?.error }}</span>
              }
              @if (physicianInfoForm.get('physicianFirstName').hasError('pattern') &&
              physicianInfoForm.get('physicianFirstName').touched) {
              <span slot="error">{{ physicianFirstNameElement?.error }}</span>
              }
              <prism-ui-input-text slot="input" is-required="true" ngDefaultControl formControlName="physicianFirstName"
                [name]="physicianFirstNameName" [formGroup]="physicianInfoForm" key-id="physicianFirstName"
                placeholder="{{ physicianFirstNameElement?.placeholder }}" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianFirstName'
                    )
                  " autocomplete="new-password" (focusout)="firstNameLeaveEvent()"
                autofill="off"></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianLastName" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'physicianLastName'
                  )
                ">
              <span slot="label" [innerHTML]="physicianLastNameElement?.label"></span>
              <span slot="helper-text" [innerHTML]="physicianLastNameElement?.hint"></span>
              @if (physicianInfoForm.get('physicianLastName').hasError('required') &&
              physicianInfoForm.get('physicianLastName').touched) {
              <span slot="error">{{ physicianLastNameElement?.error }}</span>
              }
              @if (physicianInfoForm.get('physicianLastName').hasError('maxlength') &&
              physicianInfoForm.get('physicianLastName').touched) {
              <span slot="error">{{ physicianLastNameElement?.error }}</span>
              }
              @if (physicianInfoForm.get('physicianLastName').hasError('pattern') &&
              physicianInfoForm.get('physicianLastName').touched) {
              <span slot="error">{{ physicianLastNameElement?.error }}</span>
              }
              <prism-ui-input-text slot="input" is-required="true" ngDefaultControl formControlName="physicianLastName"
                [name]="physicianLastNameName" [formGroup]="physicianInfoForm" key-id="physicianLastName"
                placeholder="{{ physicianLastNameElement?.placeholder }}" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianLastName'
                    )
                  " autocomplete="new-password" (focusout)="lastNameLeaveEvent()" autofill="off"></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
          }
          @if (physicianInfoForm.get('hasPhysician').value === 'facility') {
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianFacility" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'medicalFacility'
                  )
                ">
              <span slot="label" [innerHTML]="medicalFacilityElement?.label"></span>
              <span slot="helper-text" [innerHTML]="medicalFacilityElement?.hint"></span>
              @if (physicianInfoForm.get('medicalFacility').errors?.pattern) {
              <span slot="error">{{ medicalFacilityElement?.error }}</span>
              }
              @if (physicianInfoForm.get('medicalFacility').hasError('maxlength') &&
              physicianInfoForm.get('medicalFacility').touched) {
              <span slot="error">{{ medicalFacilityElement?.error }}</span>
              }
              @if (
              physicianInfoForm.get('medicalFacility').hasError('required')
              ) {
              <span slot="error">{{ medicalFacilityElement?.error }}</span>
              }
              <prism-ui-input-text slot="input" is-required="true" ngDefaultControl formControlName="medicalFacility"
                [name]="physicianFacilityName" [formGroup]="physicianInfoForm" key-id="medicalFacility"
                placeholder="{{ medicalFacilityElement?.placeholder }}" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'medicalFacility'
                    )
                  " autocomplete="new-password" (focusout)="medicalFacilityLeaveEvent($event)"
                autofill="off"></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
          }
        </div>
        @if (
        physicianInfoForm.get('hasPhysician').value === 'physician' ||
        physicianInfoForm.get('hasPhysician').value === 'facility'
        ) {
        <div class="containerTwo">
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianPhoneNumber" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'phoneNumber'
                  )
                ">
              <span slot="label">{{ phoneElement?.label }}</span>
              <span slot="helper-text">{{ phoneElement?.hint }}</span>
              <span slot="error">
                @if (
                physicianInfoForm.get('phoneNumber').hasError('required')
                ) {
                <span>{{ phoneElement?.error }}</span>
                }
                @if (
                physicianInfoForm.get('phoneNumber').hasError('pattern')
                ) {
                <span>{{ phoneElement?.error }}</span>
                }
              </span>
              <prism-ui-input-phone autocomplete="new-password" slot="input" autofill="off" is-required="true"
                ngDefaultControl formControlName="phoneNumber" [formGroup]="physicianInfoForm"
                [name]="physicianPhoneNumberName" key-id="physicianPhoneNumber" [placeholder]="phoneMask" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'phoneNumber'
                    )
                  " (focusout)="phoneLeaveEvent($event)">
              </prism-ui-input-phone>
            </prism-ui-form-field>
          </div>
          <div class="item oneCell">
            <prism-ui-form-field [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'country'
                  )
                " key-id="physicianCountry">
              <span slot="label" [innerHTML]="countryElement?.label"></span>
              <span slot="helper-text" [innerHTML]="countryElement?.hint"></span>
              <span slot="error">
                @if (physicianInfoForm.get('country').hasError('required')) {
                <span>{{ countryElement?.error }}</span>
                }
              </span>
              <prism-ui-select slot="input" key-id="physicianCountry" has-placeholder="true" is-required="true"
                [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm, 'country')"
                [options]="countryLabels"
                [selectedValue]="getPhysicianCountryLabel(physicianInfoForm.get('country')?.value)" ngDefaultControl
                [formGroup]="physicianInfoForm" formControlName="country"
                (selectEvent)="handleOptionSelectedPhysicianCountry($event, 'country')">
              </prism-ui-select>
            </prism-ui-form-field>
          </div>
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianLine1Name" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'physicianLine1'
                  )
                ">
              <span slot="label">{{ addressElement?.label }}</span>
              <span slot="helper-text">{{ addressElement?.hint }}</span>
              <span slot="error">
                @if (
                physicianInfoForm.get('physicianLine1').hasError('required')
                ) {
                <span>{{ addressElement?.error }}</span>
                }
                @if (
                physicianInfoForm.get('physicianLine1').errors?.pattern
                ) {
                <span>{{ addressElement?.error }}</span>
                }
              </span>
              <prism-ui-input-text autocomplete="new-password" autofill="off" slot="input" is-required="true"
                ngDefaultControl formControlName="physicianLine1" [formGroup]="physicianInfoForm"
                [maxLength]="maxLengthLine1" [name]="physicianLine1Name" key-id="physicianLine1Name"
                placeholder="{{ addressElement?.placeholder }}" (focusout)="addressLine1LeaveEvent($event)" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianLine1'
                    )
                  "></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
          <div class="item oneCell">
            <prism-ui-form-field key-id="physicianCityName" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'city'
                  )
                ">
              <span slot="label">{{ cityElement?.label }}</span>
              <span slot="helper-text">{{ cityElement?.hint }}</span>
              @if (physicianInfoForm.get('city').hasError('required') && physicianInfoForm.get('city').touched) {
              <span slot="error">{{ cityElement?.error }}</span>
              }
              @if (physicianInfoForm.get('city').hasError('maxlength') && physicianInfoForm.get('city').touched) {
              <span slot="error">{{ cityElement?.error }}</span>
              }
              @if (physicianInfoForm.get('city').hasError('pattern') && physicianInfoForm.get('city').touched) {
              <span slot="error">{{ cityElement?.error }}</span>
              }
              <prism-ui-input-text autocomplete="new-password" autofill="off" slot="input" is-required="true"
                ngDefaultControl formControlName="city" [formGroup]="physicianInfoForm" [name]="physicianCityName"
                key-id="physicianCityName" placeholder="{{ cityElement?.placeholder }}"
                (focusout)="cityLeaveEvent($event)" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'city'
                    )
                  "></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
        </div>
        <div class="containerThree">
          <div class="item oneCellGrid">
            @if (foreignAddress) {
            <prism-ui-form-field key-id="physicianForeignState" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'physicianState'
                  )
                ">
              <span slot="label">{{ stateElement?.label }}</span>
              <span slot="helper-text">{{ stateElement?.hint }}</span>
              <span slot="error">
                @if (
                physicianInfoForm
                .get('physicianState')
                .hasError('required')
                ) {
                <span>{{ stateElement?.error }}</span>
                }
                @if (
                physicianInfoForm.get('physicianState').errors?.pattern
                ) {
                <span>{{ stateElement?.error }}</span>
                }
              </span>
              <prism-ui-input-text autocomplete="new-password" autofill="off" slot="input" is-required="true"
                [maxLength]="maxLengthState" ngDefaultControl formControlName="physicianState"
                [formGroup]="physicianInfoForm" [name]="physicianForeignStateName" key-id="physicianState"
                placeholder="{{ stateElement?.placeholder }}" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianState'
                    )
                  " (focusout)="stateLeaveEvent($event)"></prism-ui-input-text>
            </prism-ui-form-field>
            }
            @if (!foreignAddress) {
            <prism-ui-form-field [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'physicianState'
                  )
                " key-id="physicianState">
              <span slot="label" [innerHTML]="stateElement?.label"></span>
              <span slot="helper-text" [innerHTML]="stateElement?.hint"></span>
              <span slot="error">
                @if (
                physicianInfoForm
                .get('physicianState')
                .hasError('required')
                ) {
                <span>{{ stateElement?.error }}</span>
                }
              </span>
              <prism-ui-select slot="input" key-id="stateElement" has-placeholder="true" is-required="true"
                [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm, 'physicianState')"
                [options]="stateRegionListLabels"
                [selectedValue]="getStateLabel(physicianInfoForm.get('physicianState')?.value)" ngDefaultControl
                [formGroup]="physicianInfoForm" formControlName="physicianState"
                (selectEvent)="handleOptionSelectedState($event, 'physicianState')">
              </prism-ui-select>
            </prism-ui-form-field>
            }
          </div>
          <div class="item oneCellGrid">
            @if (!foreignAddress) {
            <prism-ui-form-field key-id="applicantZipCode" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianZipCode'
                    )
                  ">
              <span slot="label">{{ zipElement?.label }}</span>
              <span slot="helper-text">{{ zipElement?.hint }}</span>
              <span slot="error">
                @if (
                physicianInfoForm
                .get('physicianZipCode')
                .hasError('required')
                ) {
                <span>{{ zipElement?.error }}</span>
                }
                @if (
                physicianInfoForm
                .get('physicianZipCode')
                .hasError('pattern')
                ) {
                <span>Invalid Zip Code</span>
                }
              </span>
              <prism-ui-input-text autocomplete="new-password" slot="input" is-required="true"
                [maxLength]="maxLengthZip" ngDefaultControl formControlName="physicianZipCode"
                [formGroup]="physicianInfoForm" [name]="physicianZipCodeName" key-id="physicianZipCodeName"
                placeholder="{{ zipElement?.placeholder }}" [isValid]="
                      formControlUtilitiesService.isControlValid(
                        physicianInfoForm,
                        'physicianZipCode'
                      )
                    " (focusout)="physicianZipCodeLeaveEvent($event)"></prism-ui-input-text>
            </prism-ui-form-field>
            }
            @if (foreignAddress) {
            <prism-ui-form-field key-id="applicantZipCode" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'physicianZipCode'
                    )
                  ">
              <span slot="label">{{ zipElement?.label }}</span>
              <span slot="helper-text">{{ zipElement?.hint }}</span>
              <span slot="error">
                @if (
                physicianInfoForm
                .get('physicianZipCode')
                .hasError('required')
                ) {
                <span>{{ zipElement?.error }}</span>
                }
                @if (
                physicianInfoForm
                .get('physicianZipCode')
                .hasError('pattern')
                ) {
                <span>Invalid Zip Code</span>
                }
              </span>
              <prism-ui-input-text autocomplete="new-password" slot="input" is-required="true"
                [maxLength]="maxLengthZipNonUs" ngDefaultControl formControlName="physicianZipCode"
                [formGroup]="physicianInfoForm" [name]="physicianZipCodeName" key-id="physicianZipCodeName"
                placeholder="{{ zipElement?.placeholder }}" [isValid]="
                      formControlUtilitiesService.isControlValid(
                        physicianInfoForm,
                        'physicianZipCode'
                      )
                    " (focusout)="physicianZipCodeLeaveEvent($event)"></prism-ui-input-text>
            </prism-ui-form-field>
            }
          </div>
        </div>
        @if (!isGenericDynamicForm) {
        <div class="containerDateHeader">
          <div item headerDate>
            <prism-ui-form-field key-id="physicianConsultDateError" [isValid]="physicianConsultDateValid()">
              <span slot="label">{{ lastConsultDateElement?.label }}</span>
              @if (!physicianConsultDateValid()) {
              <span slot="error">{{ lastConsultDateElement?.error }}</span>
              }
            </prism-ui-form-field>
          </div>
        </div>
        <div class="containerDateBody">
          <div class="item mm">
            <prism-ui-input-number autocomplete="new-password" autofill="off" slot="input" is-required="true"
              formControlName="lastConsultDateMonth" [name]="lastConsultDateMonthName" key-id="lastConsultDateMonth"
              ngDefaultControl placeholder="MM" max="12" min="1" max-length="2" min-length="1"
              (focusout)="lastConsultDateMonthLeaveEvent()"
              [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm, 'lastConsultDateMonth')"></prism-ui-input-number>
          </div>
          <div class="item dd">
            <prism-ui-input-number autocomplete="new-password" autofill="off" slot="input" is-required="true"
              formControlName="lastConsultDateDay" [name]="lastConsultDateDayName" key-id="lastConsultDateDay"
              ngDefaultControl placeholder="DD" max="31" min="1" max-length="2" min-length="1"
              (focusout)="lastConsultDateDayLeaveEvent()"
              [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm, 'lastConsultDateDay')"></prism-ui-input-number>
          </div>
          <div class="item yyyy">
            <prism-ui-input-number autocomplete="new-password" autofill="off" slot="input" is-required="true"
              formControlName="lastConsultDateYear" [name]="lastConsultDateYearName" key-id="lastConsultDateYear"
              ngDefaultControl placeholder="YYYY" max="startConsultDate" max-length="4" min-length="4"
              (focusout)="lastConsultDateYearLeaveEvent()"
              [isValid]="formControlUtilitiesService.isControlValid(physicianInfoForm, 'lastConsultDateYear')"></prism-ui-input-number>
          </div>
        </div>
        }
        @if (isGenericDynamicForm) {
        <app-month-picker [parentForm]="physicianInfoForm" [questionNumber]="'lastVisitDate'"
          [label]="'Last date of visit'"></app-month-picker>
        }
        <div class="containerHint">
          <div class="item PhyHint">
            <prism-ui-form-field key-id="lastConsultDateHint">
              <span slot="helper-text">{{ lastConsultDateElement?.hint }}</span>
            </prism-ui-form-field>
          </div>
        </div>
        @if (!isGenericDynamicForm) {
        <div class="item oneCell">
          <prism-ui-form-field key-id="lastConsultReason" [isValid]="
                  formControlUtilitiesService.isControlValid(
                    physicianInfoForm,
                    'lastConsultReason'
                  )
                ">
            <span slot="label" class="labelHelpLastConsultReason">
              <span class="label-text">{{
                lastConsultReasonElement?.label
                }}</span>
              <prism-ui-icon-button expanded="false" has-tooltip="true" icon-name="circle-info" is-inactive="false"
                is-waiting="false" key-id="helpLastConsultReason" label="{{ tooltipConsultReasonDescription }}"
                size="small" [tooltipPosition]="lastConsultReasonTooltipPosition" type="button" variant="tertiary"
                class="">
                <div class="lastConsultReasonTooltipWidth lastConsultReasonTooltipPadding">
                  <prism-ui-copy key-id="lastConsultReasonTooltip">{{
                    tooltipConsultReasonDescription
                    }}</prism-ui-copy>
                </div>
              </prism-ui-icon-button>
            </span>
            <span slot="helper-text">{{
              lastConsultReasonElement?.hint
              }}</span>
            @if (
            physicianInfoForm.get('lastConsultReason').errors?.pattern
            ) {
            <span slot="error">{{ lastConsultReasonElement?.error }}</span>
            }
            @if (
            physicianInfoForm
            .get('lastConsultReason')
            .hasError('required')
            ) {
            <span slot="error">{{ lastConsultReasonElement?.error }}</span>
            }
            @if (
            physicianInfoForm
            .get('lastConsultReason')
            .hasError('maxlength')
            ) {
            <span slot="error">{{ lastConsultReasonElement?.error }}</span>
            }
            <prism-ui-input-text slot="input" is-required="true" ngDefaultControl formControlName="lastConsultReason"
              [name]="lastConsultReasonName" [formGroup]="physicianInfoForm" key-id="lastConsultReason"
              [maxLength]="maxLengthName" placeholder="{{ lastConsultReasonElement?.placeholder }}" [isValid]="
                    formControlUtilitiesService.isControlValid(
                      physicianInfoForm,
                      'lastConsultReason'
                    )
                  " autocomplete="new-password" (focusout)="lastConsultReasonLeaveEvent($event)"
              autofill="off"></prism-ui-input-text>
          </prism-ui-form-field>
        </div>
        }
        }
      </div>
    </prism-ui-container>
    <div class="row continueCancelButtonPadding">
      @if (isEditFromReview) {
        <prism-ui-button-group
          key-id="physician-edit-button-group"
          buttons-count="2"
          spacing="default"
          class="editActionButtons"
        >
          <prism-ui-button
            slot="1"
            button-width="full"
            key-id="back-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            (click)="goBack()"
          >Back</prism-ui-button>
          <prism-ui-button
            slot="2"
            button-width="full"
            key-id="save-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="saveAndGoToReview()"
          >Save</prism-ui-button>
        </prism-ui-button-group>
      } @else {
        <app-continue-cancel 
          (cancelEmitter)="onCancel()" 
          (backEmitter)="onBack()"
          [showBackButton]="showBackButton"
        ></app-continue-cancel>
      }
    </div>
  </form>
</div>

@if (formSubmitted && !isEditFromReview) {
<div class="page-loader">
  <prism-ui-loader has-logo="false" is-reverse="false" key-id="page-loader" size="md">
  </prism-ui-loader>
  <prism-ui-copy font-size="md" font-style="normal" font-weight="regular" key-id="spinner-loading-text"
    line-height="medium" text-decoration="none" variant="default">
    <span>Please wait while we process your request</span>
  </prism-ui-copy>
</div>
}

<prism-ui-modal key-id="physician-modal" has-dark-overlay="true">
  <prism-ui-heading slot="modal-header" key-id="physician-modal" font-size="sm" font-weight="strong">{{
    modalContentHeading }}</prism-ui-heading>
  <prism-ui-copy slot="modal-body" key-id="physician-modal">
    {{ modalContentBody }}
  </prism-ui-copy>
  <div slot="modal-footer" style="display: flex; justify-content: center">
    <div class="row app-continue-cancel d-flex align-items-center">
      <div class="col">
        <prism-ui-button class="center" button-width="content" key-id="continue-button" size="md" variant="primary"
          type="button" is-icon-right-aligned="false" (click)="closePhysicianModal()">Close</prism-ui-button>
      </div>
    </div>
  </div>
</prism-ui-modal>